import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  ChoiceLink,
  ChoiceTitle,
  ChoiceWrapper,
  LinkWrapper,
  PrepareWrapper,
  Header,
  HeaderBodyCopy,
  StyledBodyCopy,
  StyledHr,
} from './component.styles'

const Prepare = ({ modalData }) => {
  return (
    <PrepareWrapper>
      <Header>{modalData.header}</Header>
      <StyledBodyCopy>{modalData.bodyCopy}</StyledBodyCopy>
      {modalData.choiceContent.map(choice => (
        <Fragment key={choice.id}>
          {choice.contentType.id === 'category' && (
            <ChoiceWrapper>
              <ChoiceTitle>{choice.displayTitle}</ChoiceTitle>
              <StyledHr />
              {choice.assets?.map(asset => (
                <LinkWrapper key={asset.id}>
                  <ChoiceLink
                    fileType={asset.contentType.id}
                    href={asset?.file?.file?.url}
                    key={asset.id}
                    text={asset.displayTitle}
                  />
                </LinkWrapper>
              ))}
            </ChoiceWrapper>
          )}
          {choice.contentType.id === 'headerBodyCopy' && (
            <HeaderBodyCopy>{choice.bodyCopy}</HeaderBodyCopy>
          )}
          {choice.contentType.id === 'textLinkIcon' && (
            <LinkWrapper key={choice.id}>
              <ChoiceLink
                fileType={choice?.asset?.icon || choice?.asset?.contentType?.id}
                href={
                  choice.asset.contentType.id === 'url'
                    ? choice?.asset?.url
                    : choice?.asset?.file?.file?.url
                }
                key={choice.id}
                text={choice?.asset?.displayTitle}
              />
            </LinkWrapper>
          )}
        </Fragment>
      ))}
    </PrepareWrapper>
  )
}

Prepare.propTypes = {
  modalData: PropTypes.object,
}

export default Prepare
